import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  //mode: 'hash',//安卓apk打包需要修改为 hash
  mode: 'history', // 去掉url中的#
  routes: [
    {
      path: '/',
      name: 'home',
      component: () =>
        import("@/views/home/index.vue")
    }, {
      path: '/login',
      name: 'login',
      component: () =>
        import('@/views/login/index.vue')
    }, {
      path: '/sendSuccess',
      name: 'sendSuccess',
      component: () =>
        import("@/views/login/sendSuccess.vue")
    }, {
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: () =>
        import('@/views/login/forgetPassword.vue')
    }, {
      path: '/resetPassword',
      name: 'resetPassword',
      component: () =>
        import('@/views/login/resetPassword.vue')
    }, {
      path: '/forgetPasswordSuc',
      name: 'forgetPasswordSuc',
      component: () =>
        import('@/views/login/forgetPasswordSuc.vue')
    }, {
      path: '/registerSuc',
      name: 'registerSuc',
      component: () =>
        import("@/views/login/registerSuc.vue")
    }, {
      path: '/invitationCode',
      name: 'invitationCode',
      component: () =>
        import('@/views/login/invitationCode.vue')
    }, {
      path: '/newDelivery',
      name: 'newDelivery',
      component: () =>
        import('@/views/newDelivery/index.vue')
    }, {
      path: '/selectDelivery',
      name: 'selectDelivery',
      component: () =>
        import('@/views/selectDelivery/index.vue')
    }, {
      path: '/problemFeedback',
      name: 'problemFeedback',
      component: () =>
        import('@/views/problemFeedback/index.vue')
    }, {
      path: '/deliveryList',
      name: 'deliveryList',
      component: () =>
        import('@/views/selectDelivery/list.vue')
    }, {
      path: '/problemFeedbackList',
      name: 'problemFeedbackList',
      component: () =>
        import('@/views/problemFeedback/list.vue')
    }, {
      path: '/problemFeedbackDetail',
      name: 'problemFeedbackDetail',
      component: () =>
        import('@/views/problemFeedback/detail.vue')
    }, {
      path: '/deliveryDetails',
      name: 'deliveryDetails',
      component: () =>
        import('@/views/deliveryDetails/index.vue')
    }, {
      path: '/logisticsDetails',
      name: 'logisticsDetails',
      component: () =>
        import('@/views/logisticsDetails/index.vue')
    }, {
      path: '/uploadPhoto',
      name: 'uploadPhoto',
      component: () =>
        import('@/views/selectDelivery/uploadPhoto.vue')
    },

    {
      path: '/loginPC',
      name: 'loginPC',
      component: () =>
        import('@/views/customerDelivery/login/index.vue')
    }, {
      path: '/homePC',
      name: 'homePC',
      component: () =>
        import('@/views/customerDelivery/home/index.vue')
    }, {
      path: '/sendSuccessPC',
      name: 'sendSuccessPC',
      component: () =>
        import("@/views/customerDelivery/login/sendSuccess.vue")
    }, {
      path: '/forgetPasswordPC',
      name: 'forgetPasswordPC',
      component: () =>
        import('@/views/customerDelivery/login/forgetPassword.vue')
    }, {
      path: '/resetPasswordPC',
      name: 'resetPasswordPC',
      component: () =>
        import('@/views/customerDelivery/login/resetPassword.vue')
    }, {
      path: '/forgetPasswordSucPC',
      name: 'forgetPasswordSucPC',
      component: () =>
        import('@/views/customerDelivery/login/forgetPasswordSuc.vue')
    }, {
      path: '/registerSucPC',
      name: 'registerSucPC',
      component: () =>
        import("@/views/customerDelivery/login/registerSuc.vue")
    }, {
      path: '/invitationCodePC',
      name: 'invitationCodePC',
      component: () =>
        import('@/views/customerDelivery/login/invitationCode.vue')
    }, {
      path: '/newDeliveryPC',
      name: 'newDeliveryPC',
      component: () =>
        import('@/views/customerDelivery/newDelivery/index.vue')
    }, {
      path: '/problemFeedbackPC',
      name: 'problemFeedbackPC',
      component: () =>
        import('@/views/customerDelivery/problemFeedback/index.vue')
    }, {
      path: '/deliveryListPC',
      name: 'deliveryListPC',
      component: () =>
        import('@/views/customerDelivery/selectDelivery/list.vue')
    }, {
      path: '/problemFeedbackListPC',
      name: 'problemFeedbackListPC',
      component: () =>
        import('@/views/customerDelivery/problemFeedback/list.vue')
    }, {
      path: '/problemFeedbackDetailPC',
      name: 'problemFeedbackDetailPC',
      component: () =>
        import('@/views/customerDelivery/problemFeedback/detail.vue')
    }, {
      path: '/deliveryDetailsPC',
      name: 'deliveryDetailsPC',
      component: () =>
        import('@/views/customerDelivery/deliveryDetails/index.vue')
    }, {
      path: '/logisticsDetailsPC',
      name: 'logisticsDetailsPC',
      component: () =>
        import('@/views/customerDelivery/logisticsDetails/index.vue')
    },{
      path: '/uploadPhotoPC',
      name: 'uploadPhotoPC',
      component: () =>
        import('@/views/customerDelivery/selectDelivery/uploadPhoto.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js